import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { Observable } from 'rxjs'
import { PresenterConstants } from '../presenter.constants'

@Injectable()
export class PresenterViewApiInterceptor implements HttpInterceptor {
  constructor(private router: Router) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const isPresenterViewRoute =
      this.router.url.includes(PresenterConstants.PRESENTER) && this.router.url.includes(`/${PresenterConstants.VIEW}`)

    if (!isPresenterViewRoute || !req.url.includes('/api/cms/')) {
      return next.handle(req)
    }

    const modifiedReq = req.clone({
      url: req.url.replace('/api/cms/', '/api/app/'),
      withCredentials: false,
    })

    return next.handle(modifiedReq)
  }
}
